"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ALL_DOMAINS: 'all-domains',
  MARKETING: 'marketing',
  SALES: 'sales',
  ADS: 'ads',
  BLOGS: 'blogs',
  PAGES: 'pages',
  WEBSITE: 'website',
  PAGE_BRANDING: 'branding',
  PAGE_INTEGRATIONS: 'integrations',
  PAGE_PERSONALIZATION: 'personalization',
  PAGE_SEO: 'seo-and-crawlers',
  PAGE_TEMPLATES: 'page-templates',
  SYSTEM_PAGES: 'system-pages',
  NAVIGATION: 'navigation',
  PRODUCTS: 'products',
  MEETINGS: 'meetings',
  QUOTAS: 'goals',
  DOMAINS: 'domains',
  THEMES: 'themes',
  CONTENT_MEMBERSHIP: 'content-membership',
  GENERAL: 'general',
  TEMPLATES: 'templates'
};
exports.default = _default;
module.exports = exports.default;